import * as React from 'react';

import { ISeoLinks } from '../../store/seo_links/index';
import { trackClick } from './tracking';

const styles = require('./index.css');

export interface ISeoLinksProps {
  seoLinks: ISeoLinks | null;
}

export class SeoLinks extends React.Component<ISeoLinksProps, {}> {
  public render() {
    if (!this.props.seoLinks) {
      return null;
    }

    const { seoBlocks } = this.props.seoLinks;

    if (!seoBlocks.length) {
      return null;
    }

    return (
      <div className={styles['container']}>
        {
          seoBlocks.map((seoBlock, blockIndex) => {
            return (
              <div key={`seo-block-${blockIndex}`} className={styles['seo-block']}>
                <div className={styles['title']}>{seoBlock.title}</div>
                <div className={styles['links']}>
                  {
                    seoBlock.links.map((seoLink, linkIndex) => {
                      return (
                        <a
                          onClick={() => trackClick(seoLink.uri)}
                          key={`seo-link-${linkIndex}`}
                          className={styles['link']}
                          href={seoLink.uri}
                        >
                          {seoLink.name}
                        </a>
                      );
                    })
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    );
  }
}
